module.exports = "/packs/thumbnail-top-sp-5c208e17f0a00f2475b81b8a7c11c652.png";